import { SxProps, Theme } from '@mui/material';

/**
 * Shared dialog styling. Previously duplicated across SessionDialog,
 * OngoingApplicationDialog and CookieDialog, with CountryCodeDialog reaching
 * into SessionDialog.styles to borrow it.
 */

/** Presents a dialog as a bottom sheet on small screens. */
export const smallScreenSX: SxProps<Theme> = {
    '& .MuiDialog-container': {
        alignItems: 'flex-end',
    },

    '& .MuiPaper-root': {
        width: '100%',
        margin: '0px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
    },
};

export const DialogActionStyles: SxProps<Theme> = (theme) => ({
    marginTop: '20px',
    justifyContent: 'center',
    borderWidth: '0px',
    borderTopWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.grey[300],
});

export const DialogButton: SxProps<Theme> = {
    marginTop: '10px',
    marginBottom: '10px',
};
